import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export const MethodHeart = ({ metodo, testid, inline = false }) => {
  const { user } = useAuth();
  const [fav, setFav] = useState(false);

  useEffect(() => {
    setFav(((user && user.favorite_methods) || []).includes(metodo));
  }, [user, metodo]);

  if (!user) return null;

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const next = !fav;
    setFav(next);
    try {
      await api.put(`/metodi/preferiti/${metodo}`);
    } catch {
      setFav(!next);
      toast.error("Non riesco a salvare il preferito. Riprova.");
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid={testid}
      aria-label={fav ? "Rimuovi dai metodi del cuore" : "Aggiungi ai metodi del cuore"}
      className={`${inline ? "p-1 -m-1" : "absolute bottom-1 right-1 sm:bottom-2 sm:right-2 z-10 p-2"} rounded-full transition-transform duration-300 hover:scale-110 active:scale-95`}
    >
      <Heart
        className={`w-4 h-4 sm:w-[18px] sm:h-[18px] transition-colors duration-300 ${
          fav
            ? "text-violet-300 fill-violet-300 drop-shadow-[0_0_7px_rgba(196,181,253,0.6)]"
            : "text-violet-300/40 hover:text-violet-200/80"
        }`}
      />
    </button>
  );
};
